import httpClient from "./httpClient";

// Comissão e repasse por banco, convênio e parceiro. O backend aplica o escopo de equipe do usuário
// (o mesmo do dashboard) antes de consultar a Join; `supervisorId` só vale para admin.
export async function buscarComissaoRepasse({
  supervisorId = [],
  dataInicio,
  dataFim,
  bancosIds = [],
  conveniosIds = [],
  tiposConvenio = [],
  tipoPeriodo = "APROVACAO",
} = {}) {
  const response = await httpClient.post("/api/relatorios/comissao-repasse", {
    responsavelIds: [],
    supervisorId: Array.isArray(supervisorId) ? supervisorId : [],
    dataInicio,
    dataFim,
    bancosIds: Array.isArray(bancosIds) ? bancosIds : [],
    conveniosIds: Array.isArray(conveniosIds) ? conveniosIds : [],
    tiposConvenio: Array.isArray(tiposConvenio) ? tiposConvenio : [],
    tipoPeriodo,
  });
  return response.data || { escopo: {}, linhas: [] };
}

// Churn sempre usa digitacao (CADASTRO). `dataFim` e a data de referencia da fotografia; o
// backend calcula a janela individual de cada parceiro sobre a serie materializada.
export async function buscarRelatorioChurn({ supervisorId = [], dataFim } = {}) {
  const response = await httpClient.post("/api/relatorios/churn", {
    responsavelIds: [],
    supervisorId: Array.isArray(supervisorId) ? supervisorId : [],
    // O DTO compartilhado do dashboard ainda exige as duas pontas. No churn somente dataFim e
    // usada como referencia; repetimos a data para cumprir o contrato sem inventar uma janela.
    dataInicio: dataFim,
    dataFim,
    tipoPeriodo: "CADASTRO",
  });
  return response.data || { escopo: {}, resumo: {}, parceiros: [] };
}
